/**
 * The five preset chips (v11.html markup 289, CSS `.qchips` 135–137).
 *
 * They are the first thing an investor clicks and they are free — the quota
 * only bites on typed and follow-up questions — so they are eager, clickable
 * before a byte of the thread chunk has arrived, and they warm that chunk on
 * hover.
 *
 * The chip label is the investor's phrasing; the prompt the model receives is
 * server-canonical and keyed off `key`, so a visitor cannot spend a free
 * question on a rewritten preset.
 */

import { PRESET_QUESTIONS } from '../config/preset-questions'
import { useAskProfile } from '../context/ask-profile-context'

export interface AskProfileChipsProps {
  onWarm: () => void
}

export function AskProfileChips({ onWarm }: AskProfileChipsProps) {
  const ask = useAskProfile()

  return (
    <div className="flex flex-wrap gap-1.5">
      {PRESET_QUESTIONS.map((preset, index) => (
        <button
          key={preset.key}
          type="button"
          onPointerEnter={onWarm}
          onFocus={onWarm}
          onClick={() => {
            // `order` is which chip, in what order — the whole point of the
            // event is which question an investor reaches for first.
            ask.trackEvent('ask_profile_chip_click', preset.key, { order: index })
            ask.ask({ entry: 'chip', presetKey: preset.key, text: preset.transcriptQuestion })
          }}
          className="cursor-pointer rounded-full border border-border px-3 py-1.5 text-left text-[12.5px] text-foreground transition-colors hover:border-foreground/40"
        >
          {preset.chipLabel}
        </button>
      ))}
    </div>
  )
}
